import { Configuration, LogLevel } from '@azure/msal-browser';
import { getConfig } from '../config';

/**
 * Creates the MSAL configuration from the runtime config.
 * Uses `clientId` and `authority` from `/config.json`.
 */
export function createMsalConfig(): Configuration {
  const { clientId, authority } = getConfig();

  return {
    auth: {
      clientId,
      authority,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return;
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              break;
            case LogLevel.Warning:
              console.warn(message);
              break;
          }
        },
      },
    },
  };
}

/**
 * Scopes for the interactive login (OIDC sign-in).
 */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

/**
 * Scope used to acquire an ACCESS token for the Irondome BFF API.
 *
 * Must target this App Registration's own API (App ID URI
 * `api://{clientId}`), so the resulting access token carries the correct
 * audience (the BFF/Authorizer validates `aud == clientId`) and v2.0 issuer.
 * The scope value (`user_impersonation`) is the one exposed by the app.
 */
export function apiTokenRequest() {
  const { clientId } = getConfig();
  return {
    scopes: [`api://${clientId}/user_impersonation`],
  };
}
